import * as dayjs from 'dayjs';
import { Component, ReactNode } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import Select from 'react-select';
import { CustomEvent, CustomEventPerson } from './CustomCalendar';

import 'dayjs/locale/pt-br';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import * as lodash from 'lodash';
import { AdminApi } from '../admin-api';
import './calendar.css';
import Header from './Header';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

dayjs.locale('pt-BR');

export default function DayEvents(props: any): ReactNode {
  const [searchParams] = useSearchParams();

  return (
    <DayEventsComp
      navigate={useNavigate()}
      params={useParams()}
      query={searchParams}
      {...props}
    />
  );
}

class DayEventsComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
      query?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      events: [],
      isSidebarExpanded: false,
      date: dayjs().toDate().toISOString(),
      isPrinting: false,
      eventsUpdating: [],
      users: [],
    };
  }

  state: Readonly<{
    isLoading: boolean;
    events: CustomEvent[];
    isSidebarExpanded: boolean;
    date: string;
    isPrinting: boolean;
    eventsUpdating: number[];
    users: CustomEventPerson[];
  }>;

  async componentDidMount() {
    await this.getEvents();
    await this.getUsers();
  }

  async getUsers() {
    this.setState({
      isLoading: true,
      users: [],
    });

    const _users = await AdminApi.get(`/users?onlyPro=true`);

    this.setState({
      isLoading: false,
      users: _users,
    });
  }

  async previousDay() {
    const _prev = dayjs(this.state.date).subtract(1, 'day').toISOString();

    this.setState({
      date: _prev,
    });

    await this.getEvents(_prev);
  }

  async nextDay() {
    const _next = dayjs(this.state.date).add(1, 'day').toISOString();

    this.setState({
      date: _next,
    });

    await this.getEvents(_next);
  }

  async googleSync() {
    const _ok = confirm(
      'Deseja sincronizar os eventos com a Google Agenda? Essa ação pode demorar alguns minutos.',
    );

    if (!_ok) return;

    this.setState({
      isLoading: true,
    });

    try {
      await AdminApi.post('/events/googleapi/sync', {});

      await this.getEvents(this.state.date);
    } catch (error) {
      console.error(error);
      alert(
        'Erro ao sincronizar com a Google Agenda. Verifique o console para mais detalhes.',
      );
    }

    this.setState({
      isLoading: false,
    });
  }

  async getEvents(date?: string): Promise<void> {
    this.setState({
      isLoading: true,
      events: [],
    });

    const _date = date || this.state.date;

    const _events = await AdminApi.get(
      `/events?s=${_date}&e=${_date}&status=confirmed&visibility=public`,
    );

    this.setState({
      isLoading: false,
      events: lodash.sortBy(_events, (s) => s.startAt),
    });
  }

  async setCustomerLiveConfirmed(val: boolean, event: CustomEvent) {
    this.setState({
      eventsUpdating: [this.state.eventsUpdating, event.id],
    });

    await AdminApi.put(`/events/${event.id}/set-live-confirmed`, {
      confirmed: val,
    });

    event.isCustomerLiveConfirmed = val;

    this.setState({
      eventsUpdating: this.state.eventsUpdating.filter((id) => id !== event.id),
      events: lodash.sortBy(this.state.events, (s) => s.startAt),
    });
  }

  async setIsFinished(val: boolean, event: CustomEvent) {
    this.setState({
      eventsUpdating: [this.state.eventsUpdating, event.id],
    });

    await AdminApi.put(`/events/${event.id}/set-finished`, {
      finished: val,
    });

    event.isFinished = val;

    this.setState({
      eventsUpdating: this.state.eventsUpdating.filter((id) => id !== event.id),
      events: lodash.sortBy(this.state.events, (s) => s.startAt),
    });
  }

  customPrint() {
    this.setState({
      isPrinting: true,
    });

    setTimeout(() => {
      window.print();
      this.setState({
        isPrinting: false,
      });
    }, 200);
  }

  changeSidebar(expanded: boolean) {
    this.setState({
      isSidebarExpanded: expanded,
    });
  }

  sizeClasses() {
    return this.state.isSidebarExpanded
      ? `col-md-9 col-lg-10`
      : `large-calendar`;
  }

  async changePartners(event: CustomEvent, partners: any) {
    this.setState({
      eventsUpdating: [this.state.eventsUpdating, event.id],
    });

    await AdminApi.put(`/events/${event.id}/set-partners`, {
      partners: partners ? partners.map((p: any) => p.value) : [],
    });

    event.partners = partners;

    this.setState({
      eventsUpdating: this.state.eventsUpdating.filter((id) => id !== event.id),
      events: lodash.sortBy(this.state.events, (s) => s.startAt),
    });
  }

  renderTable() {
    return (
      <table className="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>Evento</th>
            {!this.state.isPrinting && <th>Parceiros</th>}
            <th>Confirmar presença</th>
            {!this.state.isPrinting && (
              <th>
                Finalizado{' '}
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Tudo foi revisado com a profissional, dinheiro nas contas.
                  Esse atendimento foi finalizado com sucesso."
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {this.state.events.map((event: CustomEvent) => (
            <tr key={event.id}>
              <td>
                <strong>{dayjs(event.startAt).format('HH:mm')}</strong> |{' '}
                {`${event.person?.name}: ${event.title}`}
                <br />
                {!this.state.isPrinting && (
                  <small
                    dangerouslySetInnerHTML={{
                      __html: (event.description ?? 'Sem descrição').replace(
                        /\n/g,
                        '<br />',
                      ),
                    }}
                  ></small>
                )}
              </td>
              {!this.state.isPrinting && (
                <td>
                  {this.state.eventsUpdating.includes(event.id) ? (
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ width: '1.2rem', height: '1.2rem' }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isClearable={true}
                      isMulti={true}
                      name="personId"
                      options={this.state.users.map((user) => ({
                        value: user.id,
                        label: user.name,
                      }))}
                      value={
                        event.partners && event.partners.length
                          ? event.partners.map((p) => ({
                              value: p.value,
                              label: p.label,
                            }))
                          : null
                      }
                      onChange={(e: any) => {
                        this.changePartners(event, e);
                      }}
                    />
                  )}
                </td>
              )}
              <td>
                <div
                  className="form-check"
                  style={{
                    marginLeft: this.state.eventsUpdating.includes(event.id)
                      ? '0px'
                      : '10px',
                  }}
                >
                  {this.state.eventsUpdating.includes(event.id) ? (
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ width: '1.2rem', height: '1.2rem' }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckChecked"
                      style={{ transform: 'scale(1.8)', cursor: 'pointer' }}
                      checked={event.isCustomerLiveConfirmed}
                      onChange={(e) => {
                        this.setCustomerLiveConfirmed(e.target.checked, event);
                      }}
                    />
                  )}
                </div>
              </td>
              {!this.state.isPrinting && (
                <td>
                  <div
                    className="form-check"
                    style={{
                      marginLeft: this.state.eventsUpdating.includes(event.id)
                        ? '0px'
                        : '10px',
                    }}
                  >
                    {this.state.eventsUpdating.includes(event.id) ? (
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ width: '1.2rem', height: '1.2rem' }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckChecked"
                        style={{ transform: 'scale(1.8)', cursor: 'pointer' }}
                        checked={event.isFinished}
                        onChange={(e) => {
                          this.setIsFinished(e.target.checked, event);
                        }}
                      />
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : this.state.isPrinting ? (
      this.renderTable()
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
              initialExpanded={false}
              onChangeSidebar={(expanded: boolean) =>
                this.changeSidebar(expanded)
              }
            ></Sidebar>
            <main className={`ms-sm-auto px-md-4 ${this.sizeClasses()}`}>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">
                  Eventos do dia {dayjs(this.state.date).format('DD/MM/YYYY')} (
                  {dayjs(this.state.date).format('dddd')})
                </h1>
                <br />
                {this.state.events.length > 0 && (
                  <small>
                    <button
                      type="button"
                      className="btn btn-link btn-sm"
                      onClick={() => this.customPrint()}
                    >
                      Imprimir
                    </button>
                  </small>
                )}
              </div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      type="button"
                      className="btn btn-primary text-white btn-sm"
                      onClick={() => this.googleSync()}
                    >
                      Sincronizar com a Google Agenda
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <div className="btn-toolbar mb-2 mb-md-0">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-2"
                    onClick={() => {
                      this.previousDay();
                    }}
                  >
                    <i className="bi bi-chevron-left"></i>{' '}
                    {dayjs(this.state.date)
                      .subtract(1, 'day')
                      .format('DD/MM/YYYY')}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => {
                      this.nextDay();
                    }}
                  >
                    <i className="bi bi-chevron-right"></i>{' '}
                    {dayjs(this.state.date).add(1, 'day').format('DD/MM/YYYY')}
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    {this.state.events.length ? (
                      this.renderTable()
                    ) : (
                      <div className="text-center">
                        Nenhum evento encontrado
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
